import type { system } from './theme'

export * from './theme'
export { default as colors } from './colors'
export { default as shadows } from './shadows'

export type DesignSystemColors = keyof typeof system.colors
